import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {DATA_SOURCES_USAGES_STATE_NAME, DataSourcesUsagesState} from "./dataSourcesUsage";
import {DatasetUsageComponentObject, DatasetUsageComponentObjects} from '../../classes/dataset-usage-component-object';
import {Serializer, Serializers} from '../../interfaces/serializer';
import {DataSource} from '../../interfaces/data-source';
import {
  DatasetDimensionsGroupComponentObject,
  DatasetDimensionsGroupComponentObjects
} from '../../classes/dataset-dimensions-group-component-object';
import {
  DatasetMetricsGroupComponentObject,
  DatasetMetricsGroupComponentObjects
} from '../../classes/dataset-metrics-group-component-object';

export const selectDataSourcesUsageState = createFeatureSelector<DataSourcesUsagesState>(DATA_SOURCES_USAGES_STATE_NAME);

export const selectDataSourcesUsage: MemoizedSelector<object, Serializers<DataSource>> = createSelector(
  selectDataSourcesUsageState,
  (dataSourcesUsagesState: DataSourcesUsagesState) => dataSourcesUsagesState.serialized
);

export const selectDataSourceUsageComponentObjects: MemoizedSelector<object, DatasetUsageComponentObjects> = createSelector(
  selectDataSourcesUsageState,
  (dataSourcesUsagesState: DataSourcesUsagesState) => dataSourcesUsagesState.componentObjects
);

export const selectDataSourcesUsageLoading: MemoizedSelector<object, boolean> = createSelector(
  selectDataSourcesUsageState,
  (dataSourcesUsagesState: DataSourcesUsagesState) => dataSourcesUsagesState.loading
);

export const selectDataSourcesUsageLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectDataSourcesUsageState,
  (dataSourcesUsagesState: DataSourcesUsagesState) => dataSourcesUsagesState.loaded
);

export const selectDataSourcesUsageInitialized: MemoizedSelector<object, boolean> = createSelector(
  selectDataSourcesUsageState,
  (dataSourcesUsagesState: DataSourcesUsagesState) => dataSourcesUsagesState.initialized
);

export const selectDataSourcesUsagePaid: MemoizedSelector<object, Serializers<DataSource>> = createSelector(
  selectDataSourcesUsageState,
  (dataSourcesUsagesState: DataSourcesUsagesState) => dataSourcesUsagesState.paid
);

export const selectDataSourcesUsageAd: MemoizedSelector<object, Serializers<DataSource>> = createSelector(
  selectDataSourcesUsageState,
  (dataSourcesUsagesState: DataSourcesUsagesState) => dataSourcesUsagesState.ads
);

export const selectDataSourcesUsageSite: MemoizedSelector<object, Serializers<DataSource>> = createSelector(
  selectDataSourcesUsageState,
  (dataSourcesUsagesState: DataSourcesUsagesState) => dataSourcesUsagesState.sites
);

export const selectAttribution: MemoizedSelector<object, Serializer<DataSource>> = createSelector(
  selectDataSourcesUsageState,
  (state: DataSourcesUsagesState) => state.attribution
);

export const selectAttributionType: MemoizedSelector<object, string> = createSelector(
  selectDataSourcesUsageState,
  (state: DataSourcesUsagesState) => state.attribution?.relationships.data_source.data.attributes.slug
);

export const selectHasAttribution: MemoizedSelector<object, boolean> = createSelector(
  selectDataSourcesUsageState,
  (state: DataSourcesUsagesState) => state.attribution && true || false
);
